import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const IconErrorUpload = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/warning-2">
          <g id="icon">
            <path
              d="M10.0002 11.4583C9.6585 11.4583 9.37516 11.175 9.37516 10.8333V6.45831C9.37516 6.11665 9.6585 5.83331 10.0002 5.83331C10.3418 5.83331 10.6252 6.11665 10.6252 6.45831V10.8333C10.6252 11.175 10.3418 11.4583 10.0002 11.4583Z"
              fill={color}
            />
            <path
              d="M10.0002 14.375C9.77516 14.375 9.56681 14.2916 9.40848 14.1333C9.33348 14.05 9.27517 13.9583 9.22517 13.8583C9.1835 13.7583 9.16683 13.65 9.16683 13.5416C9.16683 13.325 9.25848 13.1083 9.40848 12.9499C9.71681 12.6416 10.2835 12.6416 10.5918 12.9499C10.7418 13.1083 10.8335 13.325 10.8335 13.5416C10.8335 13.65 10.8085 13.7583 10.7668 13.8583C10.7251 13.9583 10.6668 14.05 10.5918 14.1333C10.4335 14.2916 10.2252 14.375 10.0002 14.375Z"
              fill={color}
            />
            <path
              d="M10.0003 18.9583C9.44198 18.9583 8.8753 18.8166 8.3753 18.5249L3.4253 15.6666C2.4253 15.0833 1.80029 14.0083 1.80029 12.8499V7.14997C1.80029 5.99164 2.4253 4.91664 3.4253 4.3333L8.3753 1.47498C9.3753 0.891642 10.617 0.891642 11.6253 1.47498L16.5753 4.3333C17.5753 4.91664 18.2003 5.99164 18.2003 7.14997V12.8499C18.2003 14.0083 17.5753 15.0833 16.5753 15.6666L11.6253 18.5249C11.1253 18.8166 10.5586 18.9583 10.0003 18.9583ZM10.0003 2.29163C9.65865 2.29163 9.30864 2.3833 9.0003 2.5583L4.0503 5.41663C3.43364 5.77496 3.05029 6.43331 3.05029 7.14997V12.8499C3.05029 13.5583 3.43364 14.225 4.0503 14.5833L9.0003 17.4416C9.61697 17.8 10.3837 17.8 10.992 17.4416L15.942 14.5833C16.5587 14.225 16.942 13.5666 16.942 12.8499V7.14997C16.942 6.44164 16.5587 5.77496 15.942 5.41663L10.992 2.5583C10.692 2.3833 10.342 2.29163 10.0003 2.29163Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </SvgWrapper>
  );
};

export default IconErrorUpload;
